import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { AvaliacaoAdicionar, AvaliacaoLista } from 'Component/Admin/Avaliacoes';
import Buscando from 'Component/Admin/Buscando';
import SemRegistros from 'Component/Admin/SemRegistros';
import Botao from 'Component/Botao';
import { useRecuperarAvaliacoesQuery } from 'Service';

const Avaliacoes = (): React.ReactElement =>
{
    const [ modal, setModal ] = useState<boolean>(false);
    const { id = 0 } = useParams<'id'>();

    const { data: { avaliacoes } = {} , isLoading } = useRecuperarAvaliacoesQuery({
        contain: ['Modulos', 'Questoes.Alternativas'],
        options: { curso_id: id },
    });

    return (
        <div className="animate__animated animate__fadeIn">
            <div className="mb-3">
                <Botao icone="plus-lg" tema="success" onClick={ () => setModal(true) }>
                    Avaliação
                </Botao>
            </div>
            <Buscando exibir={ isLoading } />
            <SemRegistros
                carregando={ isLoading }
                registros={ avaliacoes?.length }
            />
            <div className="bg-white shadow-sm rounded">
                <div className="clip-rounded">
                    { avaliacoes?.map(avaliacao => (
                        <AvaliacaoLista
                            key={ `${avaliacao.id}-${avaliacao.modificado}` }
                            dados={ avaliacao }
                        />
                    )) }
                </div>
            </div>
            <AvaliacaoAdicionar
                cursoId={ id as number }
                exibir={ modal }
                aoFechar={ setModal }
            />
        </div>
    )
}

export default Avaliacoes;
